import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddQuizDialogBoxComponent } from '../add-quiz-dialog-box/add-quiz-dialog-box.component';
import { AddQuizAssesmentDialogComponent } from '../add-quiz-assesment-dialog/add-quiz-assesment-dialog.component';

@Component({
  selector: 'app-select-add-quiz-popup',
  standalone: true,
  imports: [],
  templateUrl: './select-add-quiz-popup.component.html',
  styleUrl: './select-add-quiz-popup.component.scss'
})
export class SelectAddQuizPopupComponent {

  constructor(
    private dialog:MatDialog,
    private dialogRef:MatDialogRef<SelectAddQuizPopupComponent>,
  ){}

    closeDialog(){
      this.dialogRef.close();
    }

    test(){
      this.closeDialog();
      this.dialog.open(AddQuizDialogBoxComponent)
    }

    test2(){
      this.closeDialog();
      this.dialog.open(AddQuizAssesmentDialogComponent)
    }

}
